import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import {utility} from "../../shared/Utility";

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  SERVER_URL = environment.serverUrl;

  constructor(private httpClient: HttpClient, private router: Router) {}

  post_(endpoint: string, request: any, options?: any): Observable<any> {
    const url = this.SERVER_URL + endpoint;
    const mergedOptions = {
      ...options,
      headers: utility.allHeader,
    };

    return this.httpClient
      .post<any>(url, request, mergedOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }


  post(endpoint: string, request: any, options?: any): Observable<any> {
    const url = this.SERVER_URL + endpoint;
    let existingHeaders =
    options?.headers instanceof HttpHeaders
      ? options.headers
      : new HttpHeaders();

      if (!(request instanceof FormData)) {
        existingHeaders = existingHeaders.set('Content-Type', 'application/json');
      }

      const mergedOptions = {
        ...options,
        headers: existingHeaders,
      };

    return this.httpClient
      .post<any>(url, request, mergedOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }


  excelPost(endpoint: string, request: any): Observable<Blob> {
    const url = this.SERVER_URL + endpoint;
  
    return this.httpClient.post(url, request, {
      responseType: 'blob',
      headers: new HttpHeaders({
       
      }),
    }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  get(endpoint: string, options?: any): Observable<any> {
    const url = this.SERVER_URL + endpoint;
    const defaultHeaders = utility.allHeader;

    const defaultOptions = { ...options, headers: defaultHeaders };

    return this.httpClient
      .get<any>(url, defaultOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unexpected error occurred. Please try again.';

    if (error.status === 0) {
      errorMessage =
        'No internet connection. Please check your network and try again.';
    } else {
      switch (error.status) {
        case 400:
          errorMessage = 'Bad request. Please check your input and try again.';

          if (error.error) {
            if (typeof error.error === 'string') {
              errorMessage = error.error;
            } else if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            }
          }
          break;
        case 403:
          errorMessage =
            "Forbidden. You don't have permission to access this resource.";
          break;
        case 404:
          errorMessage =
            'Resource not found. Please check the URL or try again later.';
          break;
        case 408:
          errorMessage =
            'The request took too long to process. Please try again later.';
          break;
        case 409:
          errorMessage =
            'Conflict detected. The request could not be completed due to a conflict.';
          break;
        case 500:
          errorMessage = 'A server error occurred. Please try again later.';

          if (error.error?.message) {
            const errorMsg = error.error.message.toLowerCase();

            if (errorMsg.includes('database')) {
              errorMessage = 'An error occurred. Please contact support.';
            } else if (errorMsg.includes('constraint')) {
              errorMessage =
                'A constraint violation occurred. Check for duplicate or invalid entries.';
            } else if (errorMsg.includes('timeout')) {
              errorMessage = 'Timeout. Please try again later.';
            } else if (errorMsg.includes('connection')) {
              errorMessage =
                'Connection error. Please contact the administrator.';
            }
          }

          break;
        case 503:
          errorMessage =
            'Service unavailable. The server is temporarily unable to handle the request.';
          break;
        case 504:
          errorMessage =
            'The server is taking too long to respond. Please check your network or try again later.';
          break;
        default:
          if (error.error) {
            if (typeof error.error === 'string') {
              errorMessage = error.error;
            } else if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            }
          }else{
            errorMessage = "Session Expired"
          }
      }
    }

    console.error('Extracted Error Message:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
